import { render, staticRenderFns } from "./ZigbeeRepeaterDevicePanel.vue?vue&type=template&id=38602380&lang=pug&"
import script from "./ZigbeeRepeaterDevicePanel.vue?vue&type=script&lang=ts&"
export * from "./ZigbeeRepeaterDevicePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports